import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
export const Reviews = () => {
  // Helper function to render stars based on rating
  const renderStars = rating => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(<StarIcon key={i} className={`w-5 h-5 ${i < rating ? 'text-green-500 fill-green-500' : 'text-gray-200'}`} data-id="element-314" />);
    }
    return <div className="flex" data-id="element-315">{stars}</div>;
  };
  return <section className="mb-10" data-id="element-316">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-317">
        Wat cursisten over ons zeggen
      </h2>
      <div className="space-y-8" data-id="element-318">
        {/* Veerle's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-319">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-320">
            <div className="flex items-center" data-id="element-321">
              <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold mr-3" data-id="element-322">
                V
              </div>
              <div data-id="element-323">
                <h3 className="font-bold" data-id="element-324">Veerle</h3>
                <div className="text-sm text-gray-500" data-id="element-325">10:33</div>
              </div>
            </div>
          </div>
          <div className="p-4" data-id="element-326">
            <p className="leading-relaxed" data-id="element-327">
              Bedankt voor je lezing, je hebt op een duidelijke manier en met
              concrete voorbeelden veel inzicht bijgebracht! Iets wat ik in de
              toekomst ook graag zou gaan doen. Veel succes nog en ik volg je
              nog op FB.
            </p>
          </div>
        </div>
        {/* Tine's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-328">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-329">
            <div className="flex items-center" data-id="element-330">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-331">
                TI
              </div>
              <div data-id="element-332">
                <div className="flex items-center" data-id="element-333">
                  <h3 className="font-bold mr-2" data-id="element-334">Tine</h3>
                  <span className="text-sm text-gray-500" data-id="element-335">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-336">•</span>
                  <span className="text-sm text-gray-500" data-id="element-337">BE</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-338">3 sep 2025</div>
          </div>
          <div className="p-4" data-id="element-339">
            <h4 className="font-bold text-lg mb-2" data-id="element-340">
              Niet goed maar uitstekend
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-341">Niet goed maar uitstekend!</p>
            <p className="leading-relaxed" data-id="element-342">
              Amée is een zeer lieve vrouw met een hart voor honden en dat merk
              jeer goed. De tips helpen echt. Ik raad iedereen met puppy's,
              jongere hondjes en alle andere leeftijden deze cursus aan, vooral
              mensen die problemen hebben met hun troetel. Zowel
              gedragsproblemen als medische problemen. Volg even de gratis
              Masterclass en je bent volledig overtuigd van de cursus en de
              mensen erachter. Heel veel liefs aan iedereen van het team.
              Groetjes Tine Oetzmann
            </p>
          </div>
        </div>
        {/* Nicolette's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-343">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-344">
            <div className="flex items-center" data-id="element-345">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-346">
                NI
              </div>
              <div data-id="element-347">
                <div className="flex items-center" data-id="element-348">
                  <h3 className="font-bold mr-2" data-id="element-349">Nicolette</h3>
                  <span className="text-sm text-gray-500" data-id="element-350">2 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-351">•</span>
                  <span className="text-sm text-gray-500" data-id="element-352">NL</span>
                </div>
                <div className="flex items-center" data-id="element-353">
                  {renderStars(5)}
                  <div className="ml-2 flex items-center text-gray-500 text-sm" data-id="element-354">
                    <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-355" />
                    Geverifieerd
                  </div>
                </div>
              </div>
            </div>
            <div className="text-gray-500" data-id="element-356">8 jul 2025</div>
          </div>
          <div className="p-4" data-id="element-357">
            <h4 className="font-bold text-lg mb-2" data-id="element-358">
              Hele fijne cursus. Aanrader zelfs voor de ervaren honden
              liefhebber.
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-359">
              Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
              Maar bij onze laatste herplaatser hebben we wel hulp nodig.
            </p>
            <p className="leading-relaxed" data-id="element-360">
              In kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
              enthousiast over deze cursus en ik kreeg ook veel hulp aangeboden.
              Het is netjes overzichtelijk, duidelijk maar wat met het meeste
              aanspreekt is dat het zonder commando's gaat maar via
              communiceren.
            </p>
          </div>
        </div>
        {/* Henne's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-361">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-362">
            <div className="flex items-center" data-id="element-363">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-364">
                HB
              </div>
              <div data-id="element-365">
                <div className="flex items-center" data-id="element-366">
                  <h3 className="font-bold mr-2" data-id="element-367">Henne Buskermolen</h3>
                  <span className="text-sm text-gray-500" data-id="element-368">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-369">•</span>
                  <span className="text-sm text-gray-500" data-id="element-370">NL</span>
                </div>
                {renderStars(4)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-371">13 aug 2025</div>
          </div>
          <div className="p-4" data-id="element-372">
            <h4 className="font-bold text-lg mb-2" data-id="element-373">
              Ik vond het prettig mijn ervaring op te...
            </h4>
            <p className="leading-relaxed" data-id="element-374">
              Ik vond het prettig mijn ervaring op te halen en voorbereid te
              zijn op de puppy die ik al snel krijg. Goed gewerkt!
            </p>
          </div>
        </div>
        {/* Margreet's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-375">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-376">
            <div className="flex items-center" data-id="element-377">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-378">
                MA
              </div>
              <div data-id="element-379">
                <div className="flex items-center" data-id="element-380">
                  <h3 className="font-bold mr-2" data-id="element-381">Margreet</h3>
                  <span className="text-sm text-gray-500" data-id="element-382">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-383">•</span>
                  <span className="text-sm text-gray-500" data-id="element-384">NL</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-385">20 apr 2025</div>
          </div>
          <div className="p-4" data-id="element-386">
            <h4 className="font-bold text-lg mb-2" data-id="element-387">
              Dit was de eerste keer dat ik een...
            </h4>
            <p className="leading-relaxed" data-id="element-388">
              Dit was de eerste keer dat ik een online hondencursus volgde en ik
              heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
              prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
              kan doen ivm de communicatie. Dat is gelukt, het valt echt op dat
              omdat ik mij zelf anders opstel, mijn honden nu veel rustiger
              communiceren met andere honden. Vooral met onbekende honden was er
              toch vaak wel flink geblaf. Nu bijna niet meer, heerlijk, wat is
              wandelen toch/weer een genot. Idd: stressless!
            </p>
          </div>
        </div>
      </div>
    </section>;
};